import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "date-placeholder"
}
const _hoisted_2 = {
  key: 1,
  class: "date-input"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Divider = _resolveComponent("Divider")
  const _component_Calendar = _resolveComponent("Calendar")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$options.first)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Select dates "))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($options.first) + " " + _toDisplayString($options.last), 1 /* TEXT */)),
    _createVNode(_component_Divider, { m: "0 -1.6rem 0" }),
    _createVNode(_component_Calendar, {
      modelValue: $data.dates,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.dates) = $event)),
      "max-date": new Date(),
      "min-date": $props.minDate,
      inline: "",
      placeholder: "Select dates",
      "selection-mode": "range"
    }, null, 8 /* PROPS */, ["modelValue", "max-date", "min-date"])
  ], 64 /* STABLE_FRAGMENT */))
}